import Vue from 'vue'

// Lib imports
import moment from 'moment'
require('moment/locale/fr')
moment.locale('fr')
Vue.prototype.$moment = moment
Vue.use(require('vue-moment'), {
  moment
})
